import { SetStateAction } from "react";
import { updateWindowValue } from "../functions/updateWindowValue";
import { stdObject } from "../../../data/types/stdObject";
import { salesCodes } from "../../../data/main";
import { toPrice } from "../../../utils/toPrice";
import { colors } from "../../../data/colors";

export const itemOptionsModal = ({
  t,
  user,
  docValues,
  modalData,
  windowValues,
  packUpdateWindow,
  getTotalProfit,
  updateItemInfo,
  closeMsg,
}: stdObject) => {
  return {
    title: modalData.title,
    inputs: [
      modalData.index > -1 && {
        label: t("c.DES"),
        value: windowValues.description,
        tabId: 0,
        type: "text",
        style: { width: 300 },
        onChange: (v: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            code: "description",
            value: v.target.value,
            ...packUpdateWindow,
          }),
      },
      ...(user[`${docValues.type}COMUS1`] && "commissions" in modalData
        ? modalData.commissions.map((e: stdObject, index: number) => {
            return (
              Array.isArray(windowValues.commissions) && {
                ...e,
                value: Number(windowValues.commissions[index]),
                tabId: 0,
                type: "number",
                active: user[`${docValues.type}COMUS1`] === 2 && e.active,
                innerStyle: { width: 50 },
                suffix: `%${e.active ? "" : ` (${t("p.paid")})`}`,
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  updateWindowValue({
                    key: "commissions",
                    code: index,
                    value: v.target.value,
                    ...packUpdateWindow,
                  }),
              }
            );
          })
        : []),
      ...(user.PCO && "info" in modalData
        ? modalData.info.map((e: stdObject) => {
            return {
              label: t(e.label),
              value: e.value,
              tabId: 0,
              type: "info",
              style: e.style ?? {},
            };
          })
        : []),
      user[`${docValues.type}COMUS1`] &&
        salesCodes
          .filter((e: string) => e !== "COT")
          .includes(docValues.type) && {
          label: t("p.commissions"),
          value:
            "commissions" in windowValues
              ? `${toPrice(
                  (windowValues.commissions.reduce(
                    (acc: number, curr: number) => acc + Number(curr),
                    0,
                  ) *
                    windowValues.price) /
                    100,
                )} (${windowValues.commissions.reduce(
                  (acc: number, curr: number) => acc + Number(curr),
                  0,
                )}%)`
              : "",
          tabId: 0,
          type: "info",
        },
      user.RENT &&
        salesCodes.includes(docValues.type) && {
          label: t("p.profitability"),
          value: `${toPrice(getTotalProfit())} (${getTotalProfit(true).toFixed(
            2,
          )}%)`,
          tabId: 0,
          type: "info",
          style: {
            color: getTotalProfit() > 0 ? colors.green : colors.red,
          },
        },
      {
        code: "REC",
        records: modalData.records,
        tabId: 2,
      },
    ],
    tabs: [
      { code: 0, label: t("p.general") },
      // modalData.serie && { code: 1, label: t("p.series") },
      { code: 2, label: t("p.records") },
    ],
    style: { height: 400 },
    buttons: [
      {
        label: t("p.update"),
        onClick: updateItemInfo,
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
